import { AppElement, html } from '../AppElement.js';
import Constants from "../Constants";
import Expand from "./Expand";

export default class ExpandAllBtn extends AppElement {
    static get properties() {
        return {
            targetSelector: { type: String },
        };
    }

    constructor(props = {}) {
        super();

        this.id = AppElement.getUniqueElementId();

        this.targetSelector = props.targetSelector;
    }

    reflow(props = {}) {
        this.targetSelector = props.targetSelector || this.targetSelector;
    }

    onClick() {
        $(this.targetSelector).find('vao-expand').each((index, elem) => {
            if (elem instanceof Expand) {
                elem.isExpanded = 'true';
            }
        });
    }

    render() {
        return html`
        <div class="vao__components--expandAllBtn">
            <vao-button 
                startIcon="${Constants.ICONS.EXPAND_ALL}" 
                variant="invert" 
                color="secondary"
                size="xs"
                @click="${this.onClick}"
            ></vao-button>
        </div>
        `;
    }
}

window.vao = window.vao || {};
window.vao.components = window.vao.components || {};
window.vao.components.ExpandAllBtn = ExpandAllBtn;
customElements.define('vao-expand-all-btn', ExpandAllBtn);